// import PropTypes from 'prop-types';
import styles from './ArtistCard.module.scss';
import React from 'react';
import Tag from '../Tag/Tag';
import Image from '../Image/Image';
import classNames from 'classnames';

const ArtistCard = ({
    link,
    image,
    title,
    tags,
    associatedActs,
    preamble,
    isLoading = false,
}) => {
    const classes = classNames(styles['ArtistCard'], {
        [styles['ArtistCard--IsLoading']]: isLoading,
    });

    return (
        <a href={link?.href} className={classes}>
            <div className={styles['ArtistCard__Container']}>
                <div className={styles['ArtistCard__ImageWrapper']}>
                    {image && !isLoading && (
                        <Image {...image} layout="fill" objectFit="cover" />
                    )}
                </div>
                <div className={styles['ArtistCard__Content']}>
                    <div className={styles['ArtistCard__InfoWrapper']}>
                        <h3 className={styles['ArtistCard__Title']}>{title}</h3>
                        <div className={styles['ArtistCard__BottomWrapper']}>
                            {tags && tags.length > 0 && (
                                <div className={styles['ArtistCard__TagList']}>
                                    <b>Gear:</b>
                                    {tags.map((tag, i) => (
                                        <p
                                            key={i}
                                            className={
                                                styles['ArtistCard__Tag']
                                            }>
                                            {tag.tag}
                                        </p>
                                    ))}
                                </div>
                            )}
                            {isLoading && (
                                <div
                                    className={
                                        styles['ArtistCard__TagListPlaceholder']
                                    }
                                />
                            )}

                            <div
                                className={
                                    styles['ArtistCard__AssociatedActsWrap']
                                }>
                                <p
                                    className={
                                        styles['ArtistCard__AssociatedActs']
                                    }>
                                    <b>Associated acts:</b>
                                    {associatedActs}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles['ArtistCard__AboutWrapper']}>
                        <p className={styles['ArtistCard__AboutText']}>
                            {preamble}
                        </p>
                    </div>
                </div>
            </div>
        </a>
    );
};

ArtistCard.propTypes = {};

ArtistCard.defaultProps = {};

export default ArtistCard;
